import { useNavigate } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { ClosedPeriodContext } from './closed-period-context.js';
import { useCompanyScope } from './company-context.js';

/// A casca entrega ao diálogo de mês fechado as permissões, o dia e o caminho do Fechamento.
export function ClosedPeriodProvider({ children }: { children: ReactNode }) {
  const { can, company, today } = useCompanyScope();
  const navigate = useNavigate();
  return (
    <ClosedPeriodContext.Provider
      value={{
        canAdjust: can('accounting.closing.adjust'),
        canReopen: can('accounting.closing.reopen'),
        today,
        openClosing: () =>
          void navigate({
            to: '/companies/$companyKey/accounting-closing',
            params: { companyKey: company.key },
          }),
      }}
    >
      {children}
    </ClosedPeriodContext.Provider>
  );
}
